module.exports = {"title":"Say Hello","body":"<form action=\"https://formspree.io/hello@johnm.io\" method=\"POST\">\n  <input required type=\"text\" e=\"name\" placeholder=\"name\">\n  <input required type=\"email\" name=\"_replyto\" placeholder=\"email\">\n  <textarea required name=\"message\">\"Hello\" </textarea>\n  <input type=\"submit\" class=\"float-right\" value=\"Send\"></form>\n</form>\n"}


/*****************
 ** WEBPACK FOOTER
 ** ./contact.md
 ** module id = 443
 ** module chunks = 0
 **/